module.exports = __webpack_public_path__ + "img/logo-simple.3f303271.png";